export const MODULE = 'purchases';